/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-destructuring */
/* eslint-disable func-names */
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.MatchingImagesInGroup.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.MatchingImagesInGroup.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.question = null;
  this.answers = [];
  this.correctAnswers = 0;
};

EDC.Games.MatchingImagesInGroup.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.MatchingImagesInGroup.Scenes.Main.prototype.constructor = EDC.Games.MatchingImagesInGroup.Scenes.Main;

const MIIG = EDC.Games.MatchingImagesInGroup.Scenes.Main.prototype;

MIIG.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

MIIG.loadIteration = function () {
  this.createQuestion();
  this.createAnswers();
};

MIIG.createAnswers = function () {
  const answersDomain = this.gameConfig.sets[this.difficulty].answersDomain;
  const correctCount = this.randomInteger(answersDomain[0], answersDomain[1]);
  this.correctAnswers = correctCount;
  const positions = {
    0: { x: 390, y: 230 },
    1: { x: 620, y: 315 },
    2: { x: 910, y: 220 },
    3: { x: 420, y: 510 },
    4: { x: 700, y: 570 },
    5: { x: 910, y: 545 },
    6: { x: 400, y: 795 },
    7: { x: 610, y: 825 },
    8: { x: 900, y: 835 },
  };
  let answers = [];
  for (let i = 0; i < correctCount; i++) {
    answers.push(this.question.imageKey);
  }
  for (let i = 0; i < 9 - correctCount; i++) {
    const rndImage = Math.floor(Math.random() * this.gameConfig.assets.images.length);
    if (answers.indexOf(rndImage) !== -1) {
      i--;
    } else {
      answers.push(rndImage);
    }
  }
  answers = this.shuffleChoices(answers);
  for (let i = 0; i < answers.length; i++) {
    const container = this.add.container(positions[i].x, positions[i].y);
    const image = this.add.sprite(0, 0, `asset-${[answers[i]]}`).setOrigin(0.5);
    image.displayWidth = 170;
    image.displayHeight = 170;
    container.add(image);
    container.setSize(170, 170);
    this.shakeAnimation(container);
    if (answers[i] === this.question.imageKey) {
      container.isCorrect = true;
    } else {
      container.isCorrect = false;
    }
    container.setInteractive();
    const markAnim = new AnswerMark(this, container).setScale(0.35);
    container.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(container);
    container.on('pointerup', this.checkAnswer.bind(this, container), this);
    this.answers.push(container);
  }
};

MIIG.shakeAnimation = function (container) {
  container.shakeAnim = this.tweens.add({
    targets: container,
    angle: 6,
    duration: 75,
    ease: 'Linear',
    delay: 6500,
    repeat: 4,
    yoyo: true,
    onComplete: this.shakeAnimation.bind(this, container),
  });
};

MIIG.checkAnswer = function (answer) {
  answer.disableInteractive();
  answer.shakeAnim.stop();
  answer.angle = 0;
  answer.isCorrect ? this.playCorrect() : this.playWrong();
  answer.getData('markAnim').showMark(answer.isCorrect, () => {});
  this.tweens.add({
    targets: answer,
    scaleX: 0.9,
    scaleY: 0.9,
    duration: 75,
    ease: 'Linear',
    yoyo: true,
  });
  if (answer.isCorrect) {
    // this.playCorrect();
    this.correctAnswers--;
    if (this.correctAnswers === 0) {
      this.answers.map((x) => {
        x.disableInteractive();
        x.shakeAnim.stop();
        x.angle = 0;
      });
      this.time.delayedCall(2000, this.shrinkAnimation, [], this);
    }
  } else {
    // this.playWrong();
    answer.getAt(0).setTint(0xff0000);
  }
};

MIIG.scaleAnimation = function (sprite, delay) {
  let randomDelay = delay;
  if (!delay) {
    randomDelay = 300;
  }
  sprite.scaleAnim = this.tweens.add({
    targets: sprite,
    scaleX: 1.1,
    scaleY: 1.1,
    duration: 400,
    ease: 'Linear',
    delay: randomDelay,
    yoyo: true,
    onComplete: this.scaleAnimation.bind(this, sprite, 6000 + Math.floor(Math.random() * 3000)),
  });
};

MIIG.shrinkAnimation = function () {
  this.iteration++;
  if (this.iteration === this.gameConfig.sets[this.difficulty].iterations) {
    this.showSummary();
  } else {
    this.answers.map((x) => {
      this.tweens.add({
        targets: x,
        scaleX: '+=0.3',
        scaleY: '+=0.3',
        duration: 300,
        ease: 'Sine.easeInOut',
        yoyo: false,
      });
      this.tweens.add({
        targets: x,
        scaleX: 0,
        scaleY: 0,
        duration: 500,
        delay: 300,
        ease: 'Sine.easeInOut',
        yoyo: false,
      });
    });
    this.tweens.add({
      targets: this.question,
      scaleX: '+=0.3',
      scaleY: '+=0.3',
      duration: 300,
      ease: 'Sine.easeInOut',
      yoyo: false,
    });
    this.tweens.add({
      targets: this.question,
      scaleX: 0,
      scaleY: 0,
      duration: 500,
      delay: 300,
      ease: 'Sine.easeInOut',
      yoyo: false,
    });
    this.time.delayedCall(1100, this.nextIteration, [], this);
  }
};

MIIG.nextIteration = function () {
  this.answers.map((x) => {
    x.destroy();
  });
  this.answers = [];
  this.question.destroy();
  this.question = null;
  this.loadIteration();
};

MIIG.shuffleChoices = function (choices) {
  let j;
  let x;
  let i;
  for (i = choices.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = choices[i];
    choices[i] = choices[j];
    choices[j] = x;
  }
  return choices;
};

MIIG.randomInteger = function (min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

MIIG.createQuestion = function () {
  const rndImage = Math.floor(Math.random() * this.gameConfig.assets.images.length);
  const container = this.add.container(1500, 580);
  const panel = this.add.sprite(0, 0, 'target-panel');
  const image = this.add.sprite(0, -30, `asset-${rndImage}`).setOrigin(0.5);
  container.add(panel);
  container.add(image);
  this.scaleAnimation(container);
  container.imageKey = rndImage;
  this.question = container;
};

MIIG.createTemplateUI = function () {
  let title;
  let instructions;
  const { titleImg } = this.gameConfig;
  const { instructionsImg } = this.gameConfig;
  if (titleImg) {
    title = this.add.sprite(1500, 70, 'title').setOrigin(0.5, 0);
  } else {
    title = this.make.text({
      x: 1540,
      y: 70,
      text: this.gameConfig.titleTxt,
      origin: { x: 0.5, y: 0 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.titleSize}`,
        wordWrap: { width: '950' },
        lineSpacing: 5,
        align: 'center',
      },
    });
  }
  if (instructionsImg) {
    instructions = this.add.sprite(1500, 810, 'instructions').setOrigin(0.5, 0);
  } else {
    instructions = this.make.text({
      x: 1540,
      y: 810,
      text: this.gameConfig.instructionsTxt,
      origin: { x: 0.5, y: 0 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.instructionsSize}`,
        wordWrap: { width: '800' },
        lineSpacing: 5,
        align: 'center',
      },
    });
  }
  const frame = this.add.sprite(700, 530, 'frame');
};

export default EDC.Games.MatchingImagesInGroup.Scenes.Main;
